import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

import { logger } from '@service-initiation/shared-clients-osp-logger';
import {
  type DeviceType,
  getDeviceTypes,
} from '@service-initiation/tech-care-data-access-tech-care-services';

const getDeviceTypesWithErrorHandling = async (
  deviceTypeId?: number
): Promise<DeviceType[] | undefined> => {
  try {
    return await getDeviceTypes({ deviceTypeId });
  } catch (e) {
    const err = e as Error;
    err.message = 'Error occurred while trying to get deviceTypes';
    logger.error(err, {
      data: { deviceTypeId },
    });
  }
};

export const availableDeviceTypeAsyncAtom = atomFamily(
  (deviceTypeId?: number) =>
    atom(async (get) => {
      const devices = await getDeviceTypesWithErrorHandling(deviceTypeId);
      return devices;
    })
);
